import { useEffect, useLayoutEffect, useRef, useState } from "react";

const useCardBackToTopButton = ({parentRef}) => {
    // Variables
    const SCROLL_CONTAINER_ID = "contentContainer";
    const THRESHOLD = 50  // px threshold

    // States
    const [show, setShow] = useState(false);
    const [position, setPosition] = useState({ left: 0 });

    // Functions
    const handleBackToTop = () => {
        const el = document.getElementById(SCROLL_CONTAINER_ID);
        if (!el) return;

        el.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };
   
    // Effects
    useEffect(() => {
        const handleScroll = () => {
            const scrollContainer = document.getElementById(SCROLL_CONTAINER_ID);
            if (scrollContainer) {
                const scrollTop = scrollContainer.scrollTop;
                setShow(scrollTop > THRESHOLD);
            }
        };

        const scrollContainer = document.getElementById(SCROLL_CONTAINER_ID);
        if (scrollContainer) {
            scrollContainer.addEventListener('scroll', handleScroll);
        }

        // Initial check
        handleScroll();

        return () => {
            if (scrollContainer) {
                scrollContainer.removeEventListener('scroll', handleScroll);
            }      
        },[];
    })

    useEffect(() => {
        if(!parentRef) return;

        const updatePosition = () => {
            if (parentRef) {
                const rect = parentRef.getBoundingClientRect();
                const left = rect.left + rect.width - 100 + 'px';
                setPosition({ left });
            }
        };

        updatePosition(); // Initial position
        window.addEventListener('resize', updatePosition);

        const resizeObserver = new ResizeObserver(updatePosition);
        if (parentRef) {
            resizeObserver.observe(parentRef);
        }

        return () => {
            window.removeEventListener('resize', updatePosition);
            resizeObserver.disconnect();
        };
    }, [parentRef]);


    return {
        handleBackToTop,
        show,
        position
    };
};

export default useCardBackToTopButton